import React from "react";
import { X } from "lucide-react";

interface ExistingImageDisplayProps {
  imageUrls: string[];
  onDelete: (imageUrl: string) => void;
}

export const ExistingImageDisplay: React.FC<ExistingImageDisplayProps> = ({ imageUrls, onDelete }) => {
  if (!imageUrls || imageUrls.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mt-4">
      {imageUrls.map((imageUrl, index) => (
        <div key={index} className="relative group">
          <div className="aspect-square rounded-lg border border-secondary-200 overflow-hidden bg-secondary-50">
            <img
              src={imageUrl}
              alt={`Claim ${index + 1}`}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
          <button
            type="button"
            onClick={() => onDelete(imageUrl)}
            className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center text-white bg-error-600 hover:bg-error-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 focus:outline-none focus:ring-2 focus:ring-error-500 focus:ring-offset-2"
            aria-label="Delete image"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};
